import React, { useState, useEffect, useRef } from "react";
import RichTextEditor from "../../Global/RichTextEditor/RichTextEditor";

const QuoteBlock = ({ onRemove, quoteBlock, onChangeText }) => {
  const [localDescription, setLocalDescription] = useState(quoteBlock?.description || "");
  const [isUserEditing, setIsUserEditing] = useState(false);
  

  const handleDescriptionChange = (name, value) => {

    console.log("handleDescriptionChange called with value:", {...quoteBlock, description: value }); 
    setIsUserEditing(true);
    if (value !== localDescription) {
      setLocalDescription(value);
      // onChangeText(name, value);
      
      onChangeText({
        ...(quoteBlock || {}),
        description: value,
      });
    }
  };

  useEffect(() => {
    if (!isUserEditing) {
      // console.log("useEffect updating localDescription from props");
      setLocalDescription(quoteBlock?.description || "");
    }
  }, [quoteBlock, isUserEditing]);

  return (
    <div className="block-container">
      <div className="block-header">
        <h4 className="block-title">Quote Block</h4>
        <div className="block-actions">
          <button className="block-action-btn remove" onClick={onRemove}>
            <span className="mdi mdi-delete"></span> Remove
          </button>
        </div>
      </div>
      <div className="card-body">
        <div className="col-lg-10 mb-4">
          <div className="form-group">
            <RichTextEditor
              name="description"
              onChange={handleDescriptionChange}
              value={localDescription}
            />
          </div>
        </div>
         <div className="row">
        <div className="col-6">
          <div className="form-group mb-3">
            <label className="form-label">Name</label>
            <input
              className="form-control"
              name="name"
              value={quoteBlock?.name || ""}
              onChange={(e) => onChangeText({...quoteBlock, name: e.target.value })}
            />
          </div>
        </div>
       
       <div className="col-6">
          <div className="form-group mb-3">
            <label className="form-label">Company</label>
            <input
              className="form-control"
              name="company"
              value={quoteBlock?.company || ""}
              onChange={(e) => onChangeText({...quoteBlock, company: e.target.value })}
            />
          </div>
        </div>
        </div>
      </div>
    </div>
  );
};

export default QuoteBlock;
